import { Grid, Image, Heading } from "@chakra-ui/react";

const Header = ({ title }: { title: string }) => {
  return (
    <Grid textAlign="center" width="full" placeItems="center" justifyContent="center" paddingTop={4} paddingBottom={8}>
      <Image pb={4} alt="logo-brand" src="/logo-brand.png" width="67.5" height="98" />
      <Heading as="h1">{title}</Heading>
    </Grid>
  );
};

export default Header;
